<template>
  <div v-if="!loading" class="form-page">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    />

    <div class="container">
      <div class="card">
        <div class="wrap-top-buttons">
          <div class="form-tabs">
            <div
              @click="tab = 'new'"
              :class="
                `common-button tab-item ${tab == 'new' ? 'selected' : ''}`
              "
            >
              {{ $t("form.tabs.submitResponse") }}
            </div>
          </div>
          <FlagButton :lang="localLanguage" @flagChange="handleFlagChange" />
        </div>
        <div class="card-body">
          <template v-if="error_load">
            <h4>
              <strong>{{ $t("messages.search_title") }}</strong>
            </h4>
            <p>{{ $t("messages.search_desc") }}</p>
          </template>
          <template v-else>
            <template v-if="respondSuccess">
              <h4>
                <strong>{{ $t("messages.sent_title") }}</strong>
              </h4>
              <p>{{ $t("messages.sent_desc") }}</p>
            </template>
            <template v-else-if="ableToView">
              <h1 class="text-certer company-name">
                {{ incidentInfo.company_name }}
              </h1>
              <div v-if="incidentInfo.logo" class="company-logo">
                <img
                  :src="incidentInfo.logo"
                  :alt="`Logo ${incidentInfo.company_name}`"
                />
              </div>

              <table style="width: 100%; table-layout: fixed;">
                <tbody>
                  <tr style="background-color: #e1e8ec">
                    <td style="width: 50%">
                      <span>
                        <strong>{{ $t("headers.protocol") }}:</strong>
                        {{ incidentInfo.protocol }}
                      </span>
                    </td>
                    <td>
                      <span>
                        <strong>{{ $t("headers.solicitation_date") }}:</strong>
                        {{ incidentInfo.created_at }}
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2" style="max-width: 0; word-wrap: break-word; overflow-wrap: break-word;">
                      <p>
                        <strong>{{ $t("form.labels.history") }}:</strong>
                      </p>
                      <div
                      v-for="message in incidents"
                      :key="message.id"
                      class="format-text">
                      <hr/>
                        <div :class="message.status == 'disable' ? 'cancelled-text' : 'submission-text'">
                          <div v-if="message.status == 'disable'">
                            <span>{{ message.created_at }} - {{ $t(`form.messageTypes.${message.type}`) }}</span>
                            <p>{{$t(`form.messageTypes.${message.type}`) + " " + $t("messages.cancelled") }}</p>
                          </div>
                          <div v-else>
                            <span>{{ message.created_at }} - {{ $t(`form.messageTypes.${message.type}`) }}</span>
                            <p>{{ message.text }}</p>
                            <div v-if="message.files && message.files.length > 0" class="chips-container">
                              <div
                                v-for="file in message.files"
                                :key="file.id"
                                class="chip"
                                @click="downloadFile(file)"
                              >
                                {{ file.title }}
                              </div>
                            </div>
                          </div>
                        </div>
                          <div v-if="message.response"
                            :class="message.response.status == 'disable' ? 'exclude-response' : 'response-text'"
                          >
                            <div v-if="message.response.status == 'disable'">
                              <span>{{ Intl.DateTimeFormat().format(new Date(message.response.created_at)) }}</span>
                              <p>{{ $t("messages.deletedTitle") }}</p>
                              <p>{{ $t("messages.deletedText") }}</p>
                            </div>
                            <div v-else>
                              <span>{{ Intl.DateTimeFormat().format(new Date(message.response.created_at)) }}</span>
                              <p>{{ message.response.text }}</p>
                              <div v-if="message.response.files && message.response.files.length > 0" class="chips-container" style="justify-content: flex-end;">
                                <div
                                  v-for="file in message.response.files"
                                  :key="file.id"
                                  class="chip"
                                  @click="downloadFile(file)"
                                >
                                  {{ file.title }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else-if="message.status == 'awaiting_response' && message.type == 'solicitation' && responses[message.token]">
                            <div class="form-container">
                              <h3 class="my-0">{{ $t("form.labels.answer") }}</h3>
                              <div class="form-group">
                                <label :for="`input-message-${message.token}`"
                                  >{{ $t("form.labels.message") }} *</label
                                >
                                <textarea
                                  :id="`input-message-${message.token}`"
                                  v-model="responses[message.token].message"
                                  :class="`input ${errors.message ? 'input-error' : ''}`"
                                  rows="5"
                                  :disabled="saving[message.token]"
                                ></textarea>

                                <small
                                  class="form-error"
                                  v-if="$v.responses.$each[message.token] && $v.responses.$each[message.token].message.$error && !$v.responses.$each[message.token].message.required"
                                >
                                  {{ $t("form.validations.message_required") }}
                                </small>
                              </div>

                              <div class="form-group">
                                <label :for="`input-files-${message.token}`"
                                  >{{ $t("form.labels.files") }}
                                </label>
                                <input
                                  :id="`input-files-${message.token}`"
                                  type="file"
                                  :disabled="saving[message.token]"
                                  @change="onFileChange($event, message.token)"
                                  class="input"
                                  multiple
                                />
                                <small v-if="!$v.responses.$each[message.token] || !$v.responses.$each[message.token].files.$error">
                                  {{ $t("form.hint.start") }} <strong>Ctrl</strong>
                                  {{ $t("form.hint.end") }}
                                </small>
                                <small
                                  class="form-error"
                                  v-if="$v.responses.$each[message.token] && $v.responses.$each[message.token].files.$error && !$v.responses.$each[message.token].files.max500mb"
                                >
                                  {{ $t("form.validations.file_size_500mb") }}
                                </small>
                              </div>

                              <div class="form-group flex-container justify-end">
                                <button
                                  :disabled="saving[message.token]"
                                  @click="postForm(message.token)"
                                  class="btn common-button"
                                  type="button"
                                >
                                  <span>{{ $t("utils.send") }}</span>
                                  <i
                                    v-if="saving[message.token]"
                                    style="margin-left:4px"
                                    class="fa fa-spin fa-spinner"
                                  ></i>
                                </button>
                              </div>
                            </div>
                          </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </template>
        </div>
      </div>
    </div>
    <BeFooter style="margin-top: 30px" background="#ffffff" />
  </div>
</template>

<script>
import FlagButton from "./FlagButton.vue";
import BeFooter from "./BeFooter.vue";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
import appApi from "@/plugins/api";
export default {
  name: "OutreachCall",
  components: { FlagButton, BeFooter },

  props: {
    msg: String,
  },

  beforeCreate() {
    document.querySelector("body").classList.add("bkg-gray");
  },
  beforeDestroy() {
    document.querySelector("body").classList.remove("bkg-gray");
  },

  data() {
    return {
      localLanguage: "pt-BR",
      loading: false,
      ableToView: false,
      solicitationAvailable: false,
      holderOccupations: [],
      saving: {},
      respondSuccess: false,
      showForm: true,
      showError: false,
      uploaded_files: {},
      options: null,
      incidents: [],
      incidentsInfo: {},
      error_load: false,
      tab: "new",
      errors: {},
      types: [],
      responses: {},

      showStatus: false,
      showErrorQuery: false,
      protocol: "",
      errorsQuery: {},
      statusText: "",
      site_url: process.env.VUE_APP_SITE_URL,
    };
  },
  validations() {
    return {
      responses: {
        $each: {
          message: { required },
          files: {
            max500mb: (files) => {
              if (files && files.length > 0) {
                let totalSize = 0;

                files.forEach((file) => {
                  totalSize += file.size;
                });

                const sizeInMb = (totalSize / (1024 * 1024)).toFixed(2);

                if (sizeInMb > 500.0) {
                  return false;
                }
              }

              return true;
            },
          },
        },
      },
    };
  },

  created() {
    this.createForm();
  },

  methods: {
    checkSizes(files) {
      if (files.length > 0) {
        let totalSize = 0;

        files.forEach((file) => {
          totalSize += file.size;
        });

        const sizeInMb = (totalSize / (1024 * 1024)).toFixed(2);

        if (sizeInMb > 500.0) {
          return false;
        }
      }

      return true;
    },
    onFileChange(e, token) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.$set(this.responses, token, {
          ...this.responses[token],
          files: []
        });
      } else {
        const fileArray = [];
        for (let i = 0; i < e.target.files.length; i++) {
          fileArray.push(e.target.files[i]);
        }
        this.$set(this.responses, token, {
          ...this.responses[token],
          files: fileArray
        });
      }
    },
    downloadFile(file) {
      axios
        .get(process.env.VUE_APP_API_URL + "files/download/" + (file.uuid || file.id), {
          params: { token: this.$route.query.token },
        })
        .then((res) => {
          window.open(res.data.url);
        })
        .catch((err) => {});
    },
    handleFlagChange(language) {
      this.localLanguage = language;
      this.createForm({ language });
    },
    handleHolderOccupationChange(value) {
      if (value !== "other") {
        this.data.holder_occupation_description = "";
      }
    },
    createForm(params = { language: "pt-BR" }) {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "lgpd-titular/outreach-communication-history?token=" +
            this.$route.query.token,
          {}
        )
        .then((res) => {
          this.incidentInfo= res.data.data[0]
          this.incidents = res.data.data

          // Inicializar responses para cada mensagem que precisa de resposta
          this.incidents.forEach((message) => {
            if (message.status === 'awaiting_response' && message.type === 'solicitation') {
              this.$set(this.responses, message.token, {
                message: '',
                files: []
              });
              this.$set(this.saving, message.token, false);
              this.$set(this.uploaded_files, message.token, []);
            }
          });

          this.ableToView = true;
          this.solicitationAvailable = true;
        })
        .catch(() => {
          this.error_load = true;
        });
    },

    postForm(token) {
      if (this.$v.responses.$each[token]) {
        this.$v.responses.$each[token].$touch();

        if (!this.$v.responses.$each[token].$invalid) {
          this.$set(this.saving, token, true);
          this.showError = false;
          this.errors = {};

          const response = this.responses[token];
          const files = response.files || [];

          if (files.length > 0) {
            let totalUploaded = 0;

            for (const file of files) {
              appApi
                .directUploadFile(file, true, null, {
                  token: token,
                })
                .then((res) => {
                  this.uploaded_files[token].push(res.data);
                  totalUploaded++;
                })
                .finally(() => {
                  if (totalUploaded == files.length) {
                    appApi
                      .postSaveOutreachCommunicationHistory({
                        token: token,
                        message: response.message,
                        uploaded_files: this.uploaded_files[token],
                      })
                      .then(() => {
                        this.showForm = false;
                        this.respondSuccess = true;
                      })
                      .catch((error) => {
                        this.error_load = true;
                      })
                      .finally(() => {
                        this.$set(this.saving, token, false);
                      });
                  }
                });
            }
          } else {
            appApi
              .postSaveOutreachCommunicationHistory({
                token: token,
                message: response.message,
                uploaded_files: [],
              })
              .then(() => {
                this.showForm = false;
                this.respondSuccess = true;
              })
              .catch((error) => {
                this.error_load = true;
              })
              .finally(() => {
                this.$set(this.saving, token, false);
              });
          }
        }
      }
    },

    getLogo() {
      return process.env.VUE_APP_LOGO;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

table td {
  border: none;
}
.table {
  border-collapse: collapse;
  border: 1px solid #2c3e50;
  width: 100%;
}

hr {
  border: unset;
  border-bottom: 1px solid #8f8f8f;
  margin-bottom: 1rem;
}

.form-container {
  margin-top: 1.5rem;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  background-color: rgba(0, 0, 0, 0.03);
}

.table th {
  text-align: left;
}

.table th,
td {
  padding: 8px;
  border: 1px solid #2c3e50;
}

.text-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
}

.table tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}

.table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

h3 {
  font-weight: normal !important;
}
.container {
  display: block;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.flex-container {
  display: flex;
  justify-content: space-between;
}

.justify-end {
  justify-content: end;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  margin-bottom: 1rem;
  background-color: #fff;
}

.my-0 {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
}

.card-body {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1.25rem;
}

.files-container {
  background-color: rgba(0, 0, 0, 0.05);
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
}

.files-container ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding-left: 1rem;
}

.mr-5 {
  margin-right: 1rem !important;
  margin-bottom: 1rem;
}

.form-page {
  display: block;
  position: relative;
  padding: 20px;
  min-height: 100vh;
  background-color: #e1e8ec;
  margin-bottom: 20px;
}
.form-page .form-group {
  margin-bottom: 20px;
  width: 100%;
  position: relative;
}
.form-page label {
  display: block;
  margin-bottom: 5px;
}

.form-page .input {
  border: 1px solid #2c3e50;
  background-color: #fff;
  min-width: 100%;
  max-width: 100%;
  border-radius: 4px;
  font-size: 15px;
  padding: 10px;
  position: relative;
  outline: none;
}

.form-page .input.input-error,
.form-page .input.input-error:focus {
  border: 1px solid #e74c3c;
}

.form-page .btn {
  background-color: #4caf50;
  border: 1px solid #ffffff;
  color: white;
  padding: 10px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 4px;
}
.form-page .btn:disabled {
  opacity: 0.4;
}
#logo {
  display: block;
  width: 80px;
}
.message-email {
  text-align: center;
  padding: 20px;
  min-height: 100vh;
}

.wrap-top-buttons {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid white;
  margin-bottom: 0.5rem;
}

.message-email .message-email-content {
  padding: 10px;
  border-radius: 5px;
  background-color: #fff;
}

.message-error {
  background-color: #e74c3c;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
}

.form-tabs {
  border-bottom: 1px solid #fff;
}

.form-tabs .tab-item {
  display: inline-block;
  padding: 5px 10px;
  background-color: #e0dcdc;
  border: 1px solid #e0dcdc;
  cursor: pointer;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.form-tabs .tab-item.selected {
  border: 1px solid #fff;
  background-color: #fff;
}
.form-tabs .tab-item:hover {
  background-color: #fff;
  border: 1px solid #fff;
}
.status-info {
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 20px;
}
.be-logo a {
  margin: 0px;
  text-align: center;
  margin-top: 10px;
  background-color: #3498db;
  padding: 10px;
  border-radius: 5px;
  display: inline-block;
}
.be-logo img {
  margin: auto;
}
.format-text {
  white-space: pre-line;
  text-align: justify;
}
.text-certer {
  text-align: center;
}
.company-name {
  margin: 20px 0px;
}
.company-logo {
  text-align: center;
}
.company-logo img {
  margin: auto;
  max-width: 200px;
  max-height: 100px;
}

.form-error {
  color: #e74c3c;
}

.wrap-footer {
  display: flex;
  justify-content: center;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f1f1f1;
  border: 1px solid #bdbdbd;
  border-radius: 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #333;
  user-select: none;
  margin-bottom: 4px;
}

.chip:hover {
  background-color: #dfdfdf;
  border-color: #9e9e9e;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chip:active {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.submission-text {
  background-color: #f5f5f5;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 12px 0;
  width: fit-content;
  max-width: 80%;
}

.response-text {
  background-color: #cff1b7;
  padding: 12px;
  border-radius: 8px;
  text-align: end;
  width: fit-content;
  max-width: 80%;
  margin-left: auto;
}

.exclude-response {
  background-color: #fcd2d2;
  padding: 12px;
  border-radius: 8px;
  text-align: end;
  width: fit-content;
  max-width: 80%;
  margin-left: auto;
}

.cancelled-text {
  background-color: #fcd2d2;
  padding: 12px 16px;
  border-radius: 8px;
  margin: 12px 0;
  width: fit-content;
  max-width: 80%;
}
</style>
